import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
// Components
import Snackbar from '@material-ui/core/Snackbar';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';

// Constants
import { NOTIFICATION_DURATION } from 'Console/constants/appConstants';

const styles = (theme) => ({
    root: {
        position: 'relative',
        marginTop: 5,
        color: '#fff',
        display: 'flex',
        padding: '6px 24px',
        'flex-wrap': 'wrap',
        'align-items': 'center',
        fontSize: theme.typography.pxToRem(14),
        zIndex: 99999,
    },
    close: {
        width: theme.typography.pxToRem(14),
        height: theme.typography.pxToRem(14),
    },
});

class Notification extends Component {
    componentDidMount() {
        setTimeout(this.popFromStack, NOTIFICATION_DURATION);
    }

    popFromStack = () => {
        const { id, popNotificationFromStack } = this.props;
        popNotificationFromStack(id);
    };

    render() {
        const { message = '', classes } = this.props;
        return (
            <div>
                <Snackbar
                    className={classes.root}
                    open
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    message={message}
                    action={
                        <IconButton
                            key="notification-close"
                            aria-label="Close"
                            color="inherit"
                            onClick={this.popFromStack}
                            fontSize="small"
                        >
                            <CloseIcon
                                className={classes.icon}
                                classes={{
                                    root: classes.close,
                                }}
                            />
                        </IconButton>
                    }
                />
            </div>
        );
    }
}

export default withStyles(styles)(Notification);
